import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Table} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { FaCheck, FaEye } from "react-icons/fa";
import AsyncSelect from 'react-select/async';
import { formataDataHoraExibicao, getCurrentUser } from '../../common/utils';

class AutorizacoesEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.state = {
            id: "",
            dados_autorizacao: {
                dados_operador: {},
                dados_gestor: {},
                dados_programa: {},
                dados_atendimento: {}
            },
            erroLoadRegistro: "",            
            titulo_pagina: "Autorização",
        };

        this.areasConfig = {
            'relatos': 'Relatos',
            'termo_programa': 'Termo do Programa', 
            'termo_laboratorio': 'Termo do Laboratório',
            'outro': 'Outro'
        }

        this.tipoSolicitacaoConfig = {
            'edicao': 'Edição',
            'exclusao': 'Exclusão',
            'adicao': 'Adição',
            'outro': 'Outro'
        }

        this.statusSolicitacaoConfig = {
            'novo': 'Novo',
            'aprovado': 'Aprovado',
            'recusado': 'Recusado',
        }
    }

    componentDidMount(){
        const id = this.props.router.params.id;
        let dados_usuario = getCurrentUser();
        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario,
            is_superuser: dados_usuario.is_superuser,
        })        

        if(id){
            this.setState({
                id: id,
                titulo_pagina: 'Autorização',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do faturamento na api
            api.get(`/autorizacoes/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',                    
                    loading: false,
                    dados_autorizacao: dados,
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar a autorização, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }
                //fora do escopo do usuário a api responde 404
                else if(error.response && error.response.status === 404){
                    erro_msg = 'Solicitação não encontrada ou fora do seu acesso';
                }

                this.setState({
                    loading: false,
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        
    }

    enviaRegistro = async (e) => {
        e.preventDefault();
        const MySwal = withReactContent(Swal);

        if(this.state.dados_autorizacao.status_solicitacao === 'recusado' && !this.state.dados_autorizacao.motivo_recusa) {
            MySwal.fire(
                'Atenção!',
                'Por favor, informe o motivo da recusa da alteração do arquivo',
                'warning'
            );

            return
        }
        
        // Confirmação de alteração de status
        const confirmacaoStatus = await MySwal.fire({
            title: 'Alterar Status',
            text: `Deseja realmente alterar o status para ${this.statusSolicitacaoConfig[this.state.dados_autorizacao.status_solicitacao]}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, alterar!',
            cancelButtonText: 'Cancelar'
        });

        if (confirmacaoStatus.isConfirmed) {
            const formData = new FormData();

            this.setState({
                loading: true,
            });
            // Adiciona o novo status ao formData
            formData.append('status_solicitacao', this.state.dados_autorizacao.status_solicitacao);
            formData.append('motivo_recusa', this.state.dados_autorizacao.motivo_recusa);
            // Envia para API
            api({
                method: 'put',
                url: '/autorizacoes/' + this.state.dados_autorizacao.id + '/',
                data: formData,
            })
            .then(response => {
                const MySwal = withReactContent(Swal);
        
                this.setState({
                    loading: false,
                });
        
                MySwal.fire({
                    title: <p>Autorização atualizada com sucesso</p>,
                    icon: 'success',
                    showCloseButton: true,
                }).then((result) => {
                    window.location.reload();
                });             
            })
            .catch(error => {
                let erro_msg = 'Erro ao atualizar a autorização, verifique os campos e tente novamente';            
        
                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                }
        
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: <p>{erro_msg}</p>,
                });
        
                this.setState({
                    loading: false,
                });
            });
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };


    render(){
        
        const statusLabel = this.statusSolicitacaoConfig[this.state.status_solicitacao];
        const currentDate = new Date().toISOString().split('T')[0];

        //solicitação fora do escopo do usuário (404) ou erro de carga: não monta os cards vazios
        if(this.state.erroLoadRegistro){
            return (
                <div>
                    <Row className="align-items-center">
                        <Col sm={6} lg={6}>
                            <h4 className="page-title">{this.state.titulo_pagina}</h4>
                        </Col>
                    </Row>
                    <Alert variant="danger">{this.state.erroLoadRegistro}</Alert>
                </div>
            )
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>    
                        <h4>Dados da Autorização</h4>
                        <Form>
                            <Row>  
                                <Col sm={6} xs={12}>
                                    <label>ID: </label>
                                    <span> {this.state.dados_autorizacao.id}</span>
                                </Col>                              
                                <Col sm={6} xs={12}>
                                    <label>Data da Solicitação: </label>
                                    <span> {formataDataHoraExibicao(this.state.dados_autorizacao.data_solicitacao)}</span>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <label>Operador: </label>
                                    <span> {this.state.dados_autorizacao.dados_operador.nome || 'Não Informado'}</span>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <label>Gestor Responsável: </label>
                                    <span> {this.state.dados_autorizacao.dados_gestor.nome || 'Sem responsável'}</span>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <label>Data de Atualização: </label>
                                    <span> {formataDataHoraExibicao(this.state.dados_autorizacao.data_atualizacao_status) || 'Não houve atualizações'}</span>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <label>Programa: </label>
                                    <span> {this.state.dados_autorizacao.dados_programa.nome || 'Não Informado'}</span>
                                </Col>  
                                <Col sm={6} xs={12}>
                                    <label>Atendimento: </label>
                                    <span> <a target="_blank" href={"/atendimentos/edit/"+this.state.dados_autorizacao.dados_atendimento.uuid}>{this.state.dados_autorizacao.dados_atendimento.id} - {this.state.dados_autorizacao.dados_atendimento.paciente}</a></span>
                                </Col>                 
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                <Card className="cardDestaque">
                    <Card.Body>    
                        <h4>Informações da Solicitação</h4>
                        <Form onSubmit={this.enviaRegistro}>
                            <Row>                           
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Área de Solicitação</Form.Label>
                                        <Form.Control type="text" name="area_solicitacao" required placeholder="Área de Solicitação" value={this.areasConfig[this.state.dados_autorizacao.area_solicitacao] || 'Não Informado'} disabled />
                                    </Form.Group>
                                </Col>              
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo de Solicitação</Form.Label>
                                        <Form.Control type="text" name="tipo_solicitacao" required placeholder="Tipo de Solicitação" value={this.tipoSolicitacaoConfig[this.state.dados_autorizacao.tipo_solicitacao] || 'Não Informado'} disabled />
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data da Atualização</Form.Label>
                                        <Form.Control type="text" name="data_atualizacao_status" required placeholder="Data da Atualização" value={formataDataHoraExibicao(this.state.dados_autorizacao.data_atualizacao_status) || 'Não Informado'} disabled />
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status da Solicitação <span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="status_solicitacao" 
                                            required 
                                            disabled={(this.state.tipo_usuario !== 'gestor' && !this.state.is_superuser) || this.state.dados_autorizacao.data_atualizacao_status !== null}
                                            value={this.state.dados_autorizacao.status_solicitacao || ''} 
                                            onChange={(e) => {
                                                const updatedDadosAutorizacao = {...this.state.dados_autorizacao, status_solicitacao: e.target.value};
                                                this.setState({ dados_autorizacao: updatedDadosAutorizacao });
                                            }}
                                        >
                                            {Object.entries(this.statusSolicitacaoConfig).map(([key, label]) => (
                                                <option key={key} value={key}>{label}</option>
                                            ))}
                                        </Form.Control>
                                        {this.state.dados_autorizacao.data_atualizacao_status === null && (
                                            <Form.Text muted>
                                                A alteração fica registrada no histórico do atendimento com o seu nome.
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                {this.state.dados_autorizacao.area_solicitacao === 'relatos' && (
                                    <>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Etapa</Form.Label>
                                            <Form.Control type="text"  value={this.state.dados_autorizacao.dados_etapa.nome || ''} disabled />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Campo</Form.Label>
                                                <Form.Control type="text"  value={this.state.dados_autorizacao.dados_formulario_campo.nome || ''} disabled />
                                            </Form.Group>
                                        </Col>
                                    </>
                                )}
                                {this.state.dados_autorizacao.status_solicitacao === 'recusado' && (
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Motivo da Recusa <span style={{ color: 'red' }}> *</span></Form.Label>
                                            <Form.Control 
                                                as="textarea" 
                                                name="motivo_recusa" 
                                                rows={3} 
                                                placeholder="Informe o motivo da recusa" 
                                                value={this.state.dados_autorizacao.motivo_recusa || ''} 
                                                onChange={(e) => {
                                                    const updatedDadosAutorizacao = {...this.state.dados_autorizacao, motivo_recusa: e.target.value};
                                                    this.setState({ dados_autorizacao: updatedDadosAutorizacao });
                                                }}
                                                disabled={(this.state.tipo_usuario !== 'gestor' && !this.state.is_superuser) || this.state.dados_autorizacao.data_atualizacao_status !== null}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}

                                <Col sm={12} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Motivo da Solicitação</Form.Label>
                                        <Form.Control 
                                            as="textarea" 
                                            name="motivo_solicitacao" 
                                            rows={3} 
                                            placeholder="Informe o motivo da solicitação" 
                                            value={this.state.dados_autorizacao.motivo_solicitacao || ''} 
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>

                                
                                <Col sm={6} xs={12}>
                                    {this.state.dados_autorizacao.arquivo_original && (
                                    <Button variant="light" className="btn-sm mb-3" href={this.state.dados_autorizacao.arquivo_original} target="_blank" style={{ marginTop: '10px' }}>
                                        <FaEye /> Ver Arquivo Original
                                    </Button>
                                    )}
                                    {this.state.dados_autorizacao.arquivo_novo && (
                                    <Button variant="light" className="btn-sm ms-4 mb-3" href={this.state.dados_autorizacao.arquivo_novo} target="_blank" style={{ marginTop: '10px' }}>
                                        <FaEye /> Ver Arquivo Novo
                                    </Button>
                                    )}
                                </Col>
                                

                                {((this.state.tipo_usuario === 'gestor' || this.state.is_superuser) && this.state.dados_autorizacao.data_atualizacao_status === null) && (
                                    <Col sm={12} xs={12}>
                                        <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                            {this.state.loading ? (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                                <>
                                                    <FaCheck className="me-1" /> Salvar Alterações
                                                </>
                                            )}
                                        </Button>
                                    </Col>
                                )}
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        )
    }
}

export default withRouter(AutorizacoesEdit);